Apt.fn.make('account.views', {
	/**
	 * Initialize module
	 */
	init() {
		const app = 'views';

		let events;

		this.index = Apt.fn.index().init({
			app: app,
			auth: true,
			view: $$('template')[0].textContent,
			path: 'account/views',
			resource: 'me/views',
			paginate: true,
			sorting: {
				'-time': 'Last seen',
				'-price': 'Price: high to low',
				'price': 'Price: low to high',
				'-size': 'Size: large to small',
				'size': 'Size: small to large'
			},
			params: {
				limit: 18
			},
			transform: Apt.properties.transform,
			model: {
				empty: 'You don\'t have any recently viewed listings.',
				label: 'property',
				standalone: true
			},
			updated: (data, init) => {
				if (! init && events) {
					events.update();
				}
			},
			unload: () => {
				if (events) {
					events.unload();
				}
			},
			destroy: () => {
				if (events) {
					events.$destroy();
				}
			}
		}, () => {
			events = Apt.fn['properties.events']()
				.init({
					app: app,
					delegate: '$results'
				});
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.destroy(this, 'index');
	}
});